import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue, off } from "firebase/database";
import { getAuth, signInWithCustomToken } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { FIREBASE_CONFIG_TYPE } from "./constant";

class FirebaseInstance {
    constructor(instanceType) {
        this.configuration = FIREBASE_CONFIG_TYPE[instanceType];
        this.firebase = initializeApp(this.configuration, instanceType);
        this.database = getDatabase(this.firebase);
        this.ref = ref;
        this.onValue = onValue;
        this.off = off;
        this.getAuth = getAuth;
        this.signInWithCustomToken = signInWithCustomToken;
        this.fireStoreDb = getFirestore(this.firebase);
    }
}

export default FirebaseInstance;

